export enum PortfolioCategoryEnum {
  darceky = 'darceky',
  tlac = 'tlac',
  scan = 'scan',
  vazby = 'vazby',
  all = '*'
}
